module.exports = __webpack_public_path__ + "img/novelty-icon.4a7048fe.svg";